<template>
  <div>
    <section class="checklist-approval-area">
      <div
        class="d-flex align-center"
        style="gap: 14px;"
      >
        <div class="checklist-approval-icon-box">
          <v-icon
            size="24"
            color="#E7E3FC"
          >
            {{ icons.mdiClipboardCheckOutline }}
          </v-icon>
        </div>
        <div class="d-flex flex-column">
          <span style="font-weight: 600; font-size: 15px; color: #E7E3FC;">Área de Aprovação de Checklists</span>
          <span style="font-weight: 500; font-size: 13px; color: #E7E3FC;">Revise e em seguida recuse ou aprove os checklists enviados</span>
        </div>
      </div>
      <div class="checklist-approval-actions">
        <v-btn
          color="error"
          outlined
          @click="openDisapproveModal()"
        >
          <div
            class="d-flex align-center"
            style="gap: 10px;"
          >
            <v-icon
              medium
            >
              {{ icons.mdiThumbDownOutline }}
            </v-icon>

            <span>RECUSAR</span>
          </div>
        </v-btn>
        <v-btn
          color="success"
          outlined
          @click="confirmApprove()"
        >
          <div
            class="d-flex align-center"
            style="gap: 10px;"
          >
            <v-icon
              medium
            >
              {{ icons.mdiThumbUpOutline }}
            </v-icon>

            <span>APROVAR E LIBERAR VIAGEM</span>
          </div>
        </v-btn>
      </div>
    </section>
    <v-dialog
      v-model="showConfirmApproveDialog"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="text-h5">
          Confirmar Aprovação
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja aprovar este checklist e liberar a viagem?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="showConfirmApproveDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmApproveWithoutIssues"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDisapproveModal"
      max-width="600px"
      transition="dialog-transition"
    >
      <DisapproveChecklistModal
        @close="showDisapproveModal = false"
        @disapprove="handleDisapprove"
      />
    </v-dialog>
    <v-dialog
      v-model="showApproveModal"
      max-width="600px"
      transition="dialog-transition"
    >
      <ApproveChecklistModal
        @close="showApproveModal = false"
        @approve="handleApprove"
      />
    </v-dialog>
  </div>
</template>

<script>
import axiosIns from '@/plugins/axios'
import { mdiClipboardCheckOutline, mdiThumbDownOutline, mdiThumbUpOutline } from '@mdi/js'
import ApproveChecklistModal from './modals/ApproveChecklistModal.vue'
import DisapproveChecklistModal from './modals/DisapproveChecklistModal.vue'

export default {
  name: 'ChecklistApprovalArea',
  components: {
    DisapproveChecklistModal,
    ApproveChecklistModal,
  },
  props: {
    checklistId: {
      type: String,
      required: true,
    },
    hasNonConformItems: {
      type: Boolean,
      default: false,
    },
    checklistType: {
      type: String,
      default: 'start',
      validator: value => ['start', 'end'].includes(value),
    },
  },
  data() {
    return {
      icons: {
        mdiClipboardCheckOutline, mdiThumbDownOutline, mdiThumbUpOutline,
      },
      showDisapproveModal: false,
      showApproveModal: false,
      showConfirmApproveDialog: false,
    }
  },
  computed: {
    approveAction() {
      return this.checklistType === 'end' ? 'approve_final_checklist' : 'approve'
    },
  },
  methods: {
    openDisapproveModal() {
      this.showDisapproveModal = true
    },

    async confirmApprove() {
      const result = await this.$swal({
        icon: 'warning',
        title: 'Aviso!',
        text: 'Confirmar a aprovação do checklist da viagem?',
        showCancelButton: true,
        confirmButtonText: 'SIM',
        cancelButtonText: 'NÃO',
        reverseButtons: true,
        cancelButtonColor: '#FF4C51',
        confirmButtonColor: '#56CA00',
        customClass: {
          actions: 'checklist-approve-confirmation-actions',
        },
      })

      if (result.isConfirmed) {
        this.confirmApproveWithoutIssues()
      }
    },

    openApproveModal() {
      // Se não há itens não conformes, mostra confirmação simples
      if (!this.hasNonConformItems) {
        this.showConfirmApproveDialog = true
      } else {
        // Se há itens não conformes, abre o modal com campo de descrição
        this.showApproveModal = true
      }
    },
    async confirmApproveWithoutIssues() {
      try {
        const payload = {
          action: this.approveAction,
          description: '',
        }

        const { data } = await axiosIns.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_or_reject/${this.checklistId}`,
          payload,
        )

        this.$swal({
          icon: 'success',
          title: 'Checklist Aprovado',
          text: 'O checklist foi aprovado e a viagem foi liberada com sucesso.',
          showConfirmButton: false,
        })

        this.$emit('approve', data)
        this.showConfirmApproveDialog = false
      } catch (error) {
        console.error('Erro ao aprovar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível aprovar o checklist. Tente novamente.',
          showCancelButton: false,
        })
      }
    },
    async handleDisapprove(description) {
      try {
        const payload = {
          action: 'reject',
          description,
        }

        const { data } = await axiosIns.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_or_reject/${this.checklistId}`,
          payload,
        )

        this.$swal({
          icon: 'success',
          title: 'Checklist Recusado',
          text: 'O checklist foi recusado com sucesso.',
          showCancelButton: false,
        })

        this.$emit('disapprove', data)
        this.showDisapproveModal = false
      } catch (error) {
        console.error('Erro ao recusar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível recusar o checklist. Tente novamente.',
          showCancelButton: false,
        })
      }
    },
    async handleApprove(description) {
      try {
        const payload = {
          action: this.approveAction,
          description,
        }

        const { data } = await axiosIns.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_or_reject/${this.checklistId}`,
          payload,
        )

        this.$swal({
          icon: 'success',
          title: 'Checklist Aprovado',
          text: 'O checklist foi aprovado e a viagem foi liberada com sucesso.',
          showCancelButton: false,
        })

        this.$emit('approve', data)
        this.showApproveModal = false
      } catch (error) {
        console.error('Erro ao aprovar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível aprovar o checklist. Tente novamente.',
          showCancelButton: false,
        })
      }
    },
  },
}
</script>

<style scoped>
.checklist-approval-area {
  border: 1px solid #534D74;
  background: transparent;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  gap: 32px;
  padding: 32px;
}
.checklist-approval-icon-box {
  width: 41px;
  height: 41px;
  border-radius: 3px;
  background-color: #9A62FD;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checklist-approval-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
}
</style>

<style>
.checklist-approve-confirmation-actions {
  width: 100%;
  gap: 100px;
}

.checklist-approve-confirmation-actions .swal2-styled {
  width: 20%;
  margin: 0;
  border-radius: 5px;
}
</style>
